import Vue from 'vue'
import { url } from '../functions'

export const Functions = Vue.mixin({
    methods: {
        url: url
    }
})
